/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S1_Provider_LabelInputs */

const tr_mesafeli_s1_provider_label = /** @type {(inputs: Mesafeli_S1_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet Sağlayıcı:`)
};

const en_mesafeli_s1_provider_label = /** @type {(inputs: Mesafeli_S1_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Provider:`)
};

const de_mesafeli_s1_provider_label = /** @type {(inputs: Mesafeli_S1_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstleistungsanbieter:`)
};

const ru_mesafeli_s1_provider_label = /** @type {(inputs: Mesafeli_S1_Provider_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик услуг:`)
};

/**
* | output |
* | --- |
* | "Service Provider:" |
*
* @param {Mesafeli_S1_Provider_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s1_provider_label = /** @type {((inputs?: Mesafeli_S1_Provider_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S1_Provider_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s1_provider_label(inputs)
	if (locale === "de") return de_mesafeli_s1_provider_label(inputs)
	if (locale === "ru") return ru_mesafeli_s1_provider_label(inputs)
	return tr_mesafeli_s1_provider_label(inputs)
});